import {
  ASSET_CREATION_FLOWS,
  type AssetCreationFlow,
  type RuntimeFlagResolutionSource,
} from "@runcheetah/shared";

export const ADMIN_ASSET_CREATION_FLOW_OPTIONS = ASSET_CREATION_FLOWS;

export const getAssetCreationFlowLabel = (flow: AssetCreationFlow): string =>
  flow === "freestyle" ? "Freestyle" : "Template";

export const getAssetCreationFlowDescription = (flow: AssetCreationFlow): string =>
  flow === "freestyle"
    ? "New single assets can be planned without a published layout template."
    : "New single assets must use a published layout template.";

export const getAssetCreationSourceLabel = (source: RuntimeFlagResolutionSource): string =>
  source === "brand" ? "Brand override" : source === "global" ? "Global default" : "Default";

export const getAssetCreationProvenanceLabel = (input: {
  flow: AssetCreationFlow;
  source: RuntimeFlagResolutionSource;
}): string =>
  `${getAssetCreationFlowLabel(input.flow)} - ${getAssetCreationSourceLabel(input.source)}`;
